import { Ship } from '../types/ship';

export const mockShips: Ship[] = [
  {
    id: 'SHP001',
    name: '한라호',
    imoNumber: '9876543',
    type: '컨테이너선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 85000,
    deadweight: 105000,
    buildYear: 2019,
    builder: '현대중공업',
    classificationSociety: 'KR',
    currentPort: '부산항',
    currentPosition: { latitude: 35.1028, longitude: 129.0403 },
    captain: '김철수',
    crewCount: 25,
    lastInspectionDate: '2025-08-15',
    nextInspectionDate: '2026-08-15',
  },
  {
    id: 'SHP002',
    name: '백두호',
    imoNumber: '9876544',
    type: '벌크선',
    status: '정박중',
    flag: '대한민국',
    grossTonnage: 62000,
    deadweight: 78000,
    buildYear: 2020,
    builder: '대우조선해양',
    classificationSociety: 'KR',
    currentPort: '인천항',
    currentPosition: { latitude: 37.4563, longitude: 126.5958 },
    captain: '이영희',
    crewCount: 22,
    lastInspectionDate: '2025-06-20',
    nextInspectionDate: '2026-06-20',
  },
  {
    id: 'SHP003',
    name: '지리산호',
    imoNumber: '9876545',
    type: '유조선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 95000,
    deadweight: 120000,
    buildYear: 2018,
    builder: '삼성중공업',
    classificationSociety: 'DNV',
    currentPort: '울산항',
    currentPosition: { latitude: 25.2744, longitude: 133.7751 },
    captain: '박민수',
    crewCount: 28,
    lastInspectionDate: '2025-09-10',
    nextInspectionDate: '2026-09-10',
  },
  {
    id: 'SHP004',
    name: '설악호',
    imoNumber: '9876546',
    type: 'LNG선',
    status: '정비중',
    flag: '대한민국',
    grossTonnage: 110000,
    deadweight: 85000,
    buildYear: 2021,
    builder: '현대중공업',
    classificationSociety: 'LR',
    currentPort: '거제조선소',
    currentPosition: { latitude: 34.8806, longitude: 128.6217 },
    captain: '최정훈',
    crewCount: 30,
    lastInspectionDate: '2025-11-05',
    nextInspectionDate: '2026-05-05',
  },
  {
    id: 'SHP005',
    name: '태백호',
    imoNumber: '9876547',
    type: '컨테이너선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 72000,
    deadweight: 90000,
    buildYear: 2022,
    builder: '한진중공업',
    classificationSociety: 'KR',
    currentPort: '싱가포르항',
    currentPosition: { latitude: 1.2644, longitude: 103.8222 },
    captain: '정승호',
    crewCount: 24,
    lastInspectionDate: '2025-07-22',
    nextInspectionDate: '2026-07-22',
  },
  {
    id: 'SHP006',
    name: '금강호',
    imoNumber: '9876548',
    type: 'LPG선',
    status: '대기중',
    flag: '대한민국',
    grossTonnage: 55000,
    deadweight: 48000,
    buildYear: 2017,
    builder: '대우조선해양',
    classificationSociety: 'ABS',
    currentPort: '여수항',
    currentPosition: { latitude: 34.7604, longitude: 127.6622 },
    captain: '한동훈',
    crewCount: 20,
    lastInspectionDate: '2025-04-18',
    nextInspectionDate: '2026-04-18',
  },
  {
    id: 'SHP007',
    name: '독도호',
    imoNumber: '9876549',
    type: '벌크선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 78000,
    deadweight: 98000,
    buildYear: 2020,
    builder: '삼성중공업',
    classificationSociety: 'KR',
    currentPort: '광양항',
    currentPosition: { latitude: -33.8688, longitude: 151.2093 },
    captain: '오세준',
    crewCount: 23,
    lastInspectionDate: '2025-10-30',
    nextInspectionDate: '2026-10-30',
  },
  {
    id: 'SHP008',
    name: '울릉호',
    imoNumber: '9876550',
    type: '자동차운반선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 68000,
    deadweight: 25000,
    buildYear: 2023,
    builder: '현대미포조선',
    classificationSociety: 'BV',
    currentPort: '평택항',
    currentPosition: { latitude: 34.0522, longitude: -118.2437 },
    captain: '윤상민',
    crewCount: 26,
    lastInspectionDate: '2025-12-01',
    nextInspectionDate: '2026-12-01',
  },
  {
    id: 'SHP009',
    name: '한강호',
    imoNumber: '9876551',
    type: '유조선',
    status: '정박중',
    flag: '대한민국',
    grossTonnage: 88000,
    deadweight: 115000,
    buildYear: 2019,
    builder: '대우조선해양',
    classificationSociety: 'DNV',
    currentPort: '대산항',
    currentPosition: { latitude: 36.9756, longitude: 126.3526 },
    captain: '강태영',
    crewCount: 27,
    lastInspectionDate: '2025-05-14',
    nextInspectionDate: '2026-05-14',
  },
  {
    id: 'SHP010',
    name: '소백호',
    imoNumber: '9876552',
    type: 'LNG선',
    status: '운항중',
    flag: '대한민국',
    grossTonnage: 120000,
    deadweight: 90000,
    buildYear: 2024,
    builder: '삼성중공업',
    classificationSociety: 'LR',
    currentPort: '카타르 라스라판항',
    currentPosition: { latitude: 25.9304, longitude: 51.5344 },
    captain: '임재현',
    crewCount: 32,
    lastInspectionDate: '2025-12-20',
    nextInspectionDate: '2026-12-20',
  },
];
